import createAxiosInstance from "./LambdaApiCierreDia";

export async function fetchFormasPagoEdith(body, accessToken) {
  const axiosInstance = await createAxiosInstance();

  const requestConfig = {
    method: "PUT", // Cambia el método si es necesario
    url: "/reclasificacion/available-fields",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: body,
  };
  return axiosInstance(requestConfig);
}
